import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PageContentContainer } from '~src/styles/containers.sc';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

import { ErrorContainer, MsgContainer, SubText } from './errorPage.sc';

interface OwnProps {
  buttonAction: () => void;
  messageKey: string;
  buttonKey: string;
}

const ErrorPage: FC<OwnProps> = React.memo(({ messageKey, buttonKey, buttonAction }) => {
  const [t] = useTranslation();
  return (
    <ErrorContainer>
      <PageContentContainer>
        <MsgContainer>
          <SubText data-translation={messageKey}>
            {t(messageKey)}
            <br />
          </SubText>
          <SecondaryButton $buttonColor="white" onClick={buttonAction}>
            <span data-translation={buttonKey}>{t(buttonKey)}</span>
          </SecondaryButton>
        </MsgContainer>
      </PageContentContainer>
    </ErrorContainer>
  );
});

export default ErrorPage;
